// Importando React y hooks useEffect y useState desde la biblioteca de React
import React, { useEffect, useState } from 'react';
// Importando el archivo CSS para el carrusel
import './carousel.css';
// Importando el componente de búsqueda
import Search from '../Search/Search';



// Definiendo el componente Carousel que recibe bannerData, search y name como props
const Carousel = ({ bannerData, search, name }) => {
  // Declarando un estado para almacenar las imágenes del carrusel
  const [images, setImages] = useState([]);

  // Usando el hook useEffect para establecer las imágenes cuando bannerData cambie
  useEffect(() => {
    // Si bannerData tiene contenido, se actualiza el estado images
    if(bannerData) {
      setImages(bannerData);
    }
  }, []); // El array vacío indica que este efecto solo se ejecuta una vez al montar el componente

  return (
    // Contenedor principal del carrusel con un identificador que recibe como prop
    
    <div id={name} className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner"> texto
        {
          // Mapeando cada elemento de bannerData para crear los items del carrusel
          bannerData.map((item, index) => (
            // Cada item tiene una clave única y clases para la activación del carrusel
            <div key={index} className={index >= 1 ? "carousel-item" : "carousel-item active"}>
              {/* Envolviendo la imagen en un enlace que lleva a la URL del item */}
              <a href={item.url} target="_blank" rel='noopener noreferrer'>
                {/* Estilo en línea para establecer la imagen de fondo */}
                <div className="img-carousel d-block w-100" style={{ backgroundImage: `url("${item.imagen}")` }} alt="First slide">
                </div>
              </a>
            </div>
          ))
        }
        
        {/*{ // Si search es true, se renderiza el componente Search search ? <Search /> : null } */}

      </div>
      {/* Botón para ir al item anterior en el carrusel */}
      <button className="carousel-control-prev" type="button" data-bs-target={"#" + name} data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      {/* Botón para ir al siguiente item en el carrusel */}
      <button className="carousel-control-next" type="button" data-bs-target={"#" + name} data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  )
}

// Exportando el componente Carousel para su uso en otras partes de la aplicación
export default Carousel;
